import { FiX } from '@react-icons/all-files/fi/FiX'
import { FiXCircle } from '@react-icons/all-files/fi/FiXCircle'

// close something, remove item, clear input/selection

export const IconX = FiX
export const IconClose = FiX
export const IconClear = FiX
export const IconXCircle = FiXCircle
export const IconCloseCircle = FiXCircle
export const IconClearCircle = FiXCircle
